var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 4.5,
    r: 0.75,
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4.5,
    r: 0.75,
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 4.5,
    r: 0.75,
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 9a.75.75 0 0 1-1.5 0V4.5a1.75 1.75 0 0 0-1.75-1.75h-15A1.75 1.75 0 0 0 2.75 4.5v15c0 .967.783 1.75 1.75 1.75H13a.75.75 0 0 1 0 1.5H4.5a3.25 3.25 0 0 1-3.25-3.25v-15A3.25 3.25 0 0 1 4.5 1.25h15a3.25 3.25 0 0 1 3.25 3.25z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.601 10.868a1.75 1.75 0 0 1 2.326-.846l1.812.845a1.751 1.751 0 0 1 .847 2.326l-3.381 7.25a.758.758 0 0 1-.29.324l-3.081 1.874a.75.75 0 0 1-1.131-.528l-.544-3.564a.749.749 0 0 1 .061-.43zm1.36.634-3.285 7.045.34 2.228 1.925-1.171 3.285-7.045a.248.248 0 0 0-.121-.332l-1.812-.846a.25.25 0 0 0-.332.121zM22 6.25a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.119 13.678a.75.75 0 1 1 .634-1.36l3.625 1.691a.75.75 0 1 1-.634 1.359zM6 11.25a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 0 1.5zM6 15.25a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 0 1.5zM6 19.25a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 0 1.5z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorChoice);
export default __webpack_public_path__ + "static/media/editor-choice.78c201ece3dd4e723aa7b8359b3a88b0.svg";
export { ForwardRef as ReactComponent };